import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelperService } from '../../services/TranslateService';
import { finalize } from 'rxjs/operators';
import { UserService } from '../../dataServices/userService';
import { AzureLoggerService } from '../../services/azureLoggerService';

@Component({
    selector: 'self-ins-forgot-password',
    templateUrl: './forgot-password-page.component.html',
    styleUrls: ['./forgot-password-page.component.scss'],
    standalone: false
})
export class ForgotPasswordPageComponent {
    public email: string = '';

    constructor(private toastrService: ToastrService,
                private userService: UserService,
                private azureLoggerService: AzureLoggerService,
                private router: Router,
                private translate: TranslateService,
                public _translateService: TranslateHelperService) {
    }

    public onSubmit() {
        this.userService.forgotPassword(this.email)
            .subscribe(
                _ => {
                    this.translate.get(this._translateService.Keys.FORGOT_PASSWORD_EMAIL_SENT, { email: this.email })
                        .subscribe((message: string) => {
                            this.toastrService.success(message);
                        });
                    setTimeout(() => this.router.navigate(['']), 1000);
                },
                error => {
                    this.azureLoggerService.logException(error);
                    this._translateService.translateAsync(this._translateService.Keys.GENERAL_ERRORS_INTERNAL_SERVER_ERROR)
                        .subscribe((message: string) => {
                            this.toastrService.error(message);
                        });
                }
            );
    }

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}